// html2canvas 1.4.1 waits for iframe.onload AND readyState=complete. WebKit can
// leave a script-created clone interactive without firing load (upstream #2864).
// Poll DOM readiness too; fonts and images are still awaited by the renderer.
export const waitForCaptureFrame = (iframe, timeoutMs = 12000) => new Promise((resolve, reject) => {
    const doc = iframe.contentWindow?.document;
    if (!doc) { reject(new Error('تعذر فتح مساحة إنشاء الملف.')); return; }
    let interval, timer;
    const finish = (error) => {
        clearInterval(interval); clearTimeout(timer);
        iframe.removeEventListener('load', check);
        if (error) { iframe.remove(); reject(error); }
        else resolve(iframe);
    };
    const check = () => {
        if (!iframe.isConnected) { finish(new Error('أُلغي إنشاء الملف.')); return; }
        const ready = doc.readyState === 'complete' || doc.readyState === 'interactive';
        // Do not take a partially styled capture just because parsing finished.
        const stylesReady = [...doc.querySelectorAll('link[rel="stylesheet"]')]
            .every(link => link.disabled || Boolean(link.sheet));
        if (ready && stylesReady && doc.body?.childNodes.length) finish();
    };
    iframe.addEventListener('load', check);
    interval = setInterval(check, 50);
    timer = setTimeout(() => finish(new Error('تعذر تهيئة المستند لإنشاء الملف. يمكنك استخدام نسخة الطباعة.')), timeoutMs);
    check();
});
